<template>
  <b-row>
    <b-col md="6">
      <b-list-group-item class="mt-2 w-100">
        <b-tree-view
          :data="listAccounts"
          ref="tree"
          :nodesDraggable="true"
          :contextMenu="false"
          :contextMenuItems="contextMenuItems"
          :renameNodeOnDblClick="false"
          :showIcons="true"
          iconClassProp="icon"
          prependIconClass="fas"
          @contextMenuItemSelect="menuItemSelected"
          @nodeSelect="nodeSelect"
        ></b-tree-view>
      </b-list-group-item>
    </b-col>
    <b-col md="6">
      <div class="card">
        <div class="card-body">{{ selectedNode.name }}</div>
      </div>
    </b-col>
  </b-row>
</template>

<script>
import { bTreeView } from 'bootstrap-vue-treeview';
export default {
  components: {
    bTreeView,
  },
  props: {
    // data: {
    //   type: Array,
    //   required: true,
    // },
    // nodeKeyProp: {
    //   type: String,
    //   required: true
    // },
    // nodeChildrenProp: {
    //   type: String,
    //   required: true
    // }
  },

  data() {
    return {
      selectedNode: '',
      listAccounts: [],
      contextMenuItems: [
        { code: 'DELETE_NODE', label: 'Delete node' },
        {
          code: 'ADD_CHILD_NODE',
          label: 'Add child',
        },
        { code: 'RENAME_NODE', label: 'Rename' },
      ],
    };
  },

  mounted() {
    this.getAccountList();
  },

  methods: {
    getAccountList() {
      this.$http
        .get(window.AppConfig.apiUrl + 'journal-account?journalAccountType=H')
        .then((response) => {
          this.listAccounts = response.data._embedded.journal_account.map((listAccount) => ({
            id: listAccount.uuid,
            name:
              listAccount.journalAccountCode +
              ' - ' +
              listAccount.journalAccountType +
              ' - ' +
              listAccount.journalAccountName,
            children: listAccount.journalAccountChild.map((child) => ({
              id: child.uuid,
              name:
                child.journalAccountCode +
                ' - ' +
                child.journalAccountType +
                ' - ' +
                child.journalAccountName,
              children: child.journalAccountChild.map((d) => ({
                id: d.uuid,
                name:
                  d.journalAccountCode +
                  ' - ' +
                  d.journalAccountType +
                  ' - ' +
                  d.journalAccountName,
                children: d.journalAccountChild.map((e) => ({
                  id: e.uuid,
                  name:
                    e.journalAccountCode +
                    ' - ' +
                    e.journalAccountType +
                    ' - ' +
                    e.journalAccountName,
                  children: e.journalAccountChild.map((f) => ({
                    id: f.uuid,
                    name:
                      f.journalAccountCode +
                      ' - ' +
                      f.journalAccountType +
                      ' - ' +
                      f.journalAccountName,
                    children: f.journalAccountChild.map((g) => ({
                      id: g.uuid,
                      name:
                        g.journalAccountCode +
                        ' - ' +
                        g.journalAccountType +
                        ' - ' +
                        g.journalAccountName,
                      children: g.journalAccountChild.map((h) => ({
                        id: h.uuid,
                        name:
                          h.journalAccountCode +
                          ' - ' +
                          h.journalAccountType +
                          ' - ' +
                          h.journalAccountName,
                      })),
                    })),
                  })),
                })),
              })),
            })),
          }));
        });
    },

    nodeSelect(node, isSelected) {
      console.log(
        'Node ' + node.data.name + ' has been ' + (isSelected ? 'selected' : 'deselected'),
      );
      if (isSelected) {
        this.selectedNode = node.data;
      } else if (node.data === this.selectedNode) {
        this.selectedNode = null;
      }
    },
    menuItemSelected(item, node) {
      if (item.code === 'ADD_CHILD_NODE') {
        node.appendChild({
          id: count++,
          name: 'My new node',
        });
      }
    },
  },
};
</script>
